// @flow

import React from "react"

export default ((
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z"
      fill="#000"
    />
    <path
      d="M23.19 13.508a1.12 1.12 0 0 0-1.065-.758H20.25V12a.752.752 0 0 0-.75-.75h-3a.752.752 0 0 0-.75.75v.75h-1.875c-.495 0-.908.315-1.065.758l-1.478 4.252a1.557 1.557 0 0 0-.082.495v5.37c0 .622.502 1.125 1.125 1.125s1.125-.503 1.125-1.125v-.375h9v.375c0 .615.503 1.125 1.125 1.125.615 0 1.125-.503 1.125-1.125v-5.37c0-.165-.03-.337-.082-.495l-1.478-4.253zM13.875 21a1.123 1.123 0 0 1-1.125-1.125c0-.622.502-1.125 1.125-1.125S15 19.253 15 19.875 14.498 21 13.875 21zm8.25 0A1.123 1.123 0 0 1 21 19.875c0-.622.503-1.125 1.125-1.125s1.125.503 1.125 1.125S22.747 21 22.125 21zm-9.375-3.75 1.125-3.375h8.25l1.125 3.375h-10.5z"
      fill="#fff"
    />
  </svg>
): React$Element<"svg">)
